import inMemoryJwt from "../auth/inMemoryJwt";
import { urlServer } from "../config/GlobalConstant";
import swal from "sweetalert2";

import {
  IS_LOADING_GET_ALL_WINERIES,
  GET_ALL_WINERIES,
  IS_LOADING_GET_ALL_SUB_WINERIES,
  GET_ALL_SUB_WINERIES,
  IS_LOADING_GET_ALL_WAREHOUSES,
  GET_ALL_WAREHOUSES,
  IS_LOADING_GET_POST_ALL_REPRESENTATIVES,
  GET_POST_ALL_REPRESENTATIVES,
  IS_LOADING_GET_ALL_FRANCHISES,
  GET_ALL_FRANCHISES,
  IS_LOADING_GET_POST_PRODUCTS_BY_LOCATION,
  GET_POST_PRODUCTS_BY_LOCATION,
  IS_LOADING_GET_POST_BATCHES_BY_LOCATION,
  GET_POST_BATCHES_BY_LOCATION,
  IS_LOADING_GET_POST_INVENTORY_CONSOLIDATE_PRODUCTS,
  GET_POST_INVENTORY_CONSOLIDATE_PRODUCTS,
} from "./types";

const Toast = swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 2000,
});

export const getProductMoreOrLessSaled = (initialDate, finalDate, reportType) => async (dispatch) => {
  await fetch(`${urlServer}productsubsales/get-report-by-type`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJwt.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: JSON.stringify({
      initialDate, finalDate, reportType
    }),
  })
    .then((response) => response.json())
    .then((respJson) => {
      if (respJson.success) {
        dispatch({
          type: "PRODUCT_GENERAL_MORE_OR_LESS_SALED",
          payload: respJson.data
        });
      }

    })
};
export const getGeneralUtility = (initialDate, finalDate) => async (dispatch) => {
  await fetch(`${urlServer}productsubsales/get-utility`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJwt.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: JSON.stringify({
      initialDate, finalDate
    }),
  })
    .then((response) => response.json())
    .then((respJson) => {
      if (respJson.success) {
        dispatch({
          type: "GET_GENERAL_UTILITY",
          payload: respJson.data
        });
      }

    })
};

export const addToConsignmentsBag = (product, stocks) => (dispatch) => {
  dispatch({
    //Esto se lo envía a combineReducer, el que está en el index 61b234836a1bb35e7dd4bd8d
    type: "ADD_TO_BAG_CONSIGNMENTS",
    payload: {
      product,
      stocks,
    },
  });
};
export const changeQuantityConsignmentsBag = (item, quantity) => (dispatch) => {
  dispatch({
    //Esto se lo envía a combineReducer, el que está en el index 61b234836a1bb35e7dd4bd8d
    type: "CHANGE_QUANTITY_CONSIGNMENTS",
    payload: { item, quantity: parseInt(quantity) },
  });
};
export const removeToConsignmentsBag = (item) => (dispatch) => {
  dispatch({ //Esto se lo envía a combineReducer, el que está en el index 61b234836a1bb35e7dd4bd8d
    type: "REMOVE_ITEM_CONSIGNMENTS",
    payload: item
  })
};

export const clearConsignmentsBag = (item) => (dispatch) => {
  dispatch({ //Esto se lo envía a combineReducer, el que está en el index 61b234836a1bb35e7dd4bd8d
    type: "ClEAR_CONSIGNMENTS_BAG"
  })
};

export const createConsignation = (id, bag, history) => async (dispatch) => {
  const items = bag.map((item) => {
    return {
      productId: item._id,
      quantity: parseInt(item.quantity),
    };
  });
  await fetch(`${urlServer}productorders/create-consignment`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJwt.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: JSON.stringify({
      transmitterEntityId: id,
      products: items
    }),
  })
    .then((response) => response.json())
    .then((respJson) => {
      if (respJson.success) {
        history.push("/Admin/Inventory/CreateConsignment")
      }

    });
};

export const getInventoryGeneral = (id) => async (dispatch) => {
  await fetch(`${urlServer}generalinventories/get-by-entity`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJwt.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: JSON.stringify({
      entityId: id,
      limit: 1000,
      skip: 0,
    }),
  })
    .then((response) => response.json())
    .then((respJson) => {
      dispatch({ type: "SEE_GENERAL_INVENTORY", payload: respJson.data });
    });
};

export const getInventoryMain = (id) => async (dispatch) => {
  await fetch(`${urlServer}mainproductbatches/get-products-by-location`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJwt.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: JSON.stringify({
      locationId: id,
      limit: 1000,
      skip: 0,
    }),
  })
    .then((response) => response.json())
    .then((respJson) => {
      dispatch({
        type: "SEE_GENERAL_INVENTORY",
        payload: respJson.data.map((item) => {
          return {
            productId: item.product[0],
            stocks: item.totalQuantityStock,
          };
        }),
      });
    });
};
export const saveCataloge = (formData) => async (dispatch) => {
  await fetch(`${urlServer}franchises/save-catalogue`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      Authorization: `bearer ${inMemoryJwt.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: formData,
  })
    .then((response) => response.json())
    .then((respJson) => { });
};

export const getDevolutionByUser = (id, status) => async (dispatch) => {
  await fetch(`${urlServer}productdevolutions/get-by-issuer`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJwt.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: JSON.stringify({
      entityId: id,
    }),
  })
    .then((response) => response.json())
    .then((respJson) => {
      if (respJson.success) {
        dispatch({ type: "GET_DEVOLUTIONS_BY_USER", payload: respJson.data });
      }
    });
};
export const removeItemSale = (item) => async dispatch => {
  dispatch({ //Esto se lo envía a combineReducer, el que está en el index 61b234836a1bb35e7dd4bd8d
    type: "REMOVE_ITEM_SALE",
    payload: item
  })
}
export const getSalesByStatus = (id, status) => async (dispatch) => {
  await fetch(`${urlServer}productsales/get-status`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJwt.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: JSON.stringify({
      sellerEntityId: id,
      status: status,
    }),
  })
    .then((response) => response.json())
    .then((respJson) => {
      dispatch({ type: "GET_SALES", payload: respJson.data });
    });
};

export const addToSaleBag = (product, stocks) => (dispatch) => {
  dispatch({
    //Esto se lo envía a combineReducer, el que está en el index 61b234836a1bb35e7dd4bd8d
    type: "ADD_TO_BAG_SALES",
    payload: {
      product,
      stocks,
    },
  });
};
export const changeQuantitySales = (item, quantity) => async (dispatch) => {
  dispatch({
    //Esto se lo envía a combineReducer, el que está en el index 61b234836a1bb35e7dd4bd8d
    type: "CHANGE_QUANTITY_SALES",
    payload: { item, quantity: parseInt(quantity) },
  });
};

export const getSubSales = (saleId) => async (dispatch) => {
  await fetch(`${urlServer}productsubsales/get-by-sale`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJwt.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: JSON.stringify({
      saleId,
    }),
  })
    .then((response) => response.json())
    .then((respJson) => {
      if (respJson.success) {
        dispatch({
          type: "SEE_SUB_SALES",
          payload: respJson.data,
        });
      } else {
        dispatch({
          type: "SEE_SUB_SALES",
          payload: [],
        });
      }
    });
};

export const registerSale =
  (identificationNumber, id, bag, history) => async (dispatch) => {
    const items = bag.map((item) => {
      return {
        productId: item._id,
        quantity: parseInt(item.quantity),
      };
    });

    await fetch(`${urlServer}productsales/create`, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      withCredentials: true,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${inMemoryJwt.getToken()}`,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({
        sellerEntityId: id,
        buyerIdentification: identificationNumber,
        products: items,
      }),
    })

      .then((response) => response.json())
      .then((respJson) => {
        if (respJson.success) {

          dispatch({
            type: "CLEAR_SALES"
          });
          history.push(`/Inventory/sale/${respJson.data._id}`);
        }
        else {
          if (respJson?.error?.error === 'ERR031') {
            Toast.fire({
              icon: 'error',
              title: 'Verifique la identificación'
            })
          }
          if (respJson?.error?.error?.error?.code === 'ERR070') {
            Toast.fire({
              icon: 'error',
              title: 'Revise las cantidades del stock'
            })
          }
        }
      });
  };

export const getBatchesGeneral = (entityId, productId) => async (dispatch) => {
  await fetch(`${urlServer}generalproductbatches/get-by-entity-product`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJwt.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: JSON.stringify({
      entityId,
      productId,
    }),
  })
    .then((response) => response.json())
    .then((respJson) => {
      if (respJson.success) {
        dispatch({
          type: "SEE_BATCHES_BY_PRODUCT",
          payload: respJson.data,
        });
      } else {
        dispatch({
          type: "SEE_BATCHES_BY_PRODUCT",
          payload: [],
        });
      }
    });
};

export const clearBatches = () => (dispatch) => {
  dispatch({
    type: "CLEAR_BATCHES_BY_PRODUCT_AND_USER",
    payload: [],
  });

}
export const getBatchesMain = (locationId, productId) => async (dispatch) => {
  await fetch(`${urlServer}mainproductbatches/get-by-location-product`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJwt.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: JSON.stringify({
      locationId,
      productId,
    }),
  })
    .then((response) => response.json())
    .then((respJson) => {
      if (respJson.success) {
        dispatch({
          type: "SEE_BATCHES_BY_PRODUCT",
          payload: respJson.data,
        });
      } else {
        dispatch({
          type: "SEE_BATCHES_BY_PRODUCT",
          payload: [],
        });
      }
    });
};
export const manageSale =
  (orderId, status, specifications, history) => async (dispatch) => {
    await fetch(`${urlServer}productsales/manage`, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      withCredentials: true,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${inMemoryJwt.getToken()}`,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({
        orderId,
        status,
        specifications,
      }),
    })
      .then((response) => response.json())
      .then((respJson) => {
        if (respJson.success) {
          history.push("/Inventory");
        }
      });
  };

export const getAllWineries = (textString, limit, skip) => async (dispatch) => {
  dispatch({ type: IS_LOADING_GET_ALL_WINERIES });

  await fetch(`${urlServer}wineries/get-all`, {
    method: "POST",
    mode: "cors",
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJwt.getToken()}`,
    },
    body: JSON.stringify({
      textString,
      limit,
      skip,
    }),
  })
    .then((response) => response.json())
    .then((respJson) => {
      if (respJson.success) {
        if (respJson.data.length > 0) {
          dispatch({
            type: GET_ALL_WINERIES,
            payload: { data: respJson.data, skip, hasMore: true },
          });
        } else {
          dispatch({
            type: GET_ALL_WINERIES,
            payload: { data: [], skip, hasMore: false },
          });
        }
      }
    })
    .catch((error) => {
      Toast.fire({
        icon: "error",
        title: "Error al obtener las bodegas",
      });
    });
};

export const getAllSubWineries =
  (textString, limit, skip) => async (dispatch) => {
    dispatch({ type: IS_LOADING_GET_ALL_SUB_WINERIES });

    await fetch(`${urlServer}wineries/subwineries/get-all`, {
      method: "POST",
      mode: "cors",
      withCredentials: true,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${inMemoryJwt.getToken()}`,
      },
      body: JSON.stringify({
        textString,
        limit,
        skip,
      }),
    })
      .then((response) => response.json())
      .then((respJson) => {
        if (respJson.success) {
          if (respJson.data.length > 0) {
            dispatch({
              type: GET_ALL_SUB_WINERIES,
              payload: { data: respJson.data, skip, hasMore: true },
            });
          } else {
            dispatch({
              type: GET_ALL_SUB_WINERIES,
              payload: { data: [], skip, hasMore: false },
            });
          }
        }
      })
      .catch((error) => {
        Toast.fire({
          icon: "error",
          title: "Error al obtener las sub bodegas",
        });
      });
  };

export const getAllWarehouses =
  (textString, limit, skip) => async (dispatch) => {
    dispatch({ type: IS_LOADING_GET_ALL_WAREHOUSES });

    await fetch(`${urlServer}warehouses/get-all`, {
      method: "POST",
      mode: "cors",
      withCredentials: true,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${inMemoryJwt.getToken()}`,
      },
      body: JSON.stringify({
        textString,
        limit,
        skip,
      }),
    })
      .then((response) => response.json())
      .then((respJson) => {
        if (respJson.success) {
          if (respJson.data.length > 0) {
            dispatch({
              type: GET_ALL_WAREHOUSES,
              payload: { data: respJson.data, skip, hasMore: true },
            });
          } else {
            dispatch({
              type: GET_ALL_WAREHOUSES,
              payload: { data: [], skip, hasMore: false },
            });
          }
        }
      })
      .catch((error) => {
        Toast.fire({
          icon: "error",
          title: "Error al obtener los almacenes",
        });
      });
  };




export const getAllRepresentatives =
  (textString, limit, skip) => async (dispatch) => {
    dispatch({ type: IS_LOADING_GET_POST_ALL_REPRESENTATIVES });

    await fetch(`${urlServer}representatives/get-all`, {
      method: "POST",
      mode: "cors",
      withCredentials: true,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${inMemoryJwt.getToken()}`,
      },
      body: JSON.stringify({
        textString,
        limit,
        skip,
      }),
    })
      .then((response) => response.json())
      .then((respJson) => {
        if (respJson.success) {
          if (respJson.data.length > 0) {
            dispatch({
              type: GET_POST_ALL_REPRESENTATIVES,
              payload: { data: respJson.data, skip, hasMore: true },
            });
          } else {
            dispatch({
              type: GET_POST_ALL_REPRESENTATIVES,
              payload: { data: [], skip, hasMore: false },
            });
          }
        }
      })
      .catch((error) => {
        Toast.fire({
          icon: "error",
          title: "Error al obtener los EcoMaster",
        });
      });
  };

export const getAllFranchises =
  (textString, limit, skip) => async (dispatch) => {
    dispatch({ type: IS_LOADING_GET_ALL_FRANCHISES });

    await fetch(`${urlServer}franchises/get-all`, {
      method: "POST",
      mode: "cors",
      withCredentials: true,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${inMemoryJwt.getToken()}`,
      },
      body: JSON.stringify({
        textString,
        limit,
        skip,
      }),
    })
      .then((response) => response.json())
      .then((respJson) => {
        if (respJson.success) {
          if (respJson.data.length > 0) {
            dispatch({
              type: GET_ALL_FRANCHISES,
              payload: { data: respJson.data, skip, hasMore: true },
            });
          } else {
            dispatch({
              type: GET_ALL_FRANCHISES,
              payload: { data: [], skip, hasMore: false },
            });
          }
        }
      })
      .catch((error) => {
        Toast.fire({
          icon: "error",
          title: "Error al obtener las EcoTiendas",
        });
      });
  };

export const getProductsByLocation =
  (locationId, limit, skip) => async (dispatch) => {
    dispatch({ type: IS_LOADING_GET_POST_PRODUCTS_BY_LOCATION });

    await fetch(`${urlServer}mainproductbatches/get-products-by-location`, {
      method: "POST",
      mode: "cors",
      withCredentials: true,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${inMemoryJwt.getToken()}`,
      },
      body: JSON.stringify({
        locationId,
        limit,
        skip,
      }),
    })
      .then((response) => response.json())
      .then((respJson) => {
        if (respJson.success) {
          if (respJson.data.length > 0) {
            dispatch({
              type: GET_POST_PRODUCTS_BY_LOCATION,
              payload: { data: respJson.data, skip, hasMore: true },
            });
          } else {
            dispatch({
              type: GET_POST_PRODUCTS_BY_LOCATION,
              payload: { data: [], skip, hasMore: false },
            });
          }
        }
      })
      .catch((error) => {
        Toast.fire({
          icon: "error",
          title: "Error al obtener las EcoTiendas",
        });
      });
  };

export const clearProductsBy = () => dispatch => {
  dispatch({
    type: "CLEAN_POST_PRODUCTS_BY_LOCATION"
  })
}
export const getProductsByEntity =
  (entityId, limit, skip) => async (dispatch) => {
    dispatch({ type: IS_LOADING_GET_POST_PRODUCTS_BY_LOCATION });

    await fetch(`${urlServer}generalinventories/get-by-entity`, {
      method: "POST",
      mode: "cors",
      withCredentials: true,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${inMemoryJwt.getToken()}`,
      },
      body: JSON.stringify({
        entityId,
        limit,
        skip,
      }),
    })
      .then((response) => response.json())
      .then((respJson) => {
        if (respJson.success) {
          if (respJson.data.length > 0) {
            dispatch({
              type: GET_POST_PRODUCTS_BY_LOCATION,
              payload: { data: respJson.data, skip, hasMore: true },
            });
          } else {
            dispatch({
              type: GET_POST_PRODUCTS_BY_LOCATION,
              payload: { data: [], skip, hasMore: false },
            });
          }
        }
      })
      .catch((error) => {
        Toast.fire({
          icon: "error",
          title: "Error al obtener las EcoTiendas",
        });
      });
  };

export const getBatchesByLocation =
  (productId, locationId) => async (dispatch) => {

    dispatch({ type: IS_LOADING_GET_POST_BATCHES_BY_LOCATION });

    await fetch(`${urlServer}mainproductbatches/get-by-location-product`, {
      method: "POST",
      mode: "cors",
      withCredentials: true,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${inMemoryJwt.getToken()}`,
      },
      body: JSON.stringify({
        productId,
        locationId,
      }),
    })
      .then((response) => response.json())
      .then((respJson) => {
        if (respJson.success) {
          dispatch({
            type: GET_POST_BATCHES_BY_LOCATION,
            payload: respJson.data,
          });
        }
      })
      .catch((error) => {
        Toast.fire({
          icon: "error",
          title: "Error al obtener las EcoTiendas",
        });
      });
  };

export const getInventoryConsolidateProducts =
  (skip, limit) => async (dispatch) => {
    dispatch({ type: IS_LOADING_GET_POST_INVENTORY_CONSOLIDATE_PRODUCTS });

    await fetch(`${urlServer}maininventories/get-consolidate-products`, {
      method: "POST",
      mode: "cors",
      withCredentials: true,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${inMemoryJwt.getToken()}`,
      },
      body: JSON.stringify({
        limit,
        skip,
      }),
    })
      .then((response) => response.json())
      .then((respJson) => {
        if (respJson.success) {
          if (respJson.data.length > 0) {
            dispatch({
              type: GET_POST_INVENTORY_CONSOLIDATE_PRODUCTS,
              payload: { data: respJson.data, skip, hasMore: true },
            });
          } else {
            dispatch({
              type: GET_POST_INVENTORY_CONSOLIDATE_PRODUCTS,
              payload: { data: [], skip, hasMore: false },
            });
          }
        }
      })
      .catch((error) => {
        Toast.fire({
          icon: "error",
          title: "Error al obtener el consolidado de productos",
        });
      });
  };

export const getBatchesByEntity = (entityId, productId) => async (dispatch) => {
  dispatch({ type: IS_LOADING_GET_POST_BATCHES_BY_LOCATION });

  await fetch(`${urlServer}generalproductbatches/get-by-entity-product`, {
    method: "POST",
    mode: "cors",
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJwt.getToken()}`,
    },
    body: JSON.stringify({
      entityId,
      productId,
    }),
  })
    .then((response) => response.json())
    .then((respJson) => {
      if (respJson.success) {
        dispatch({
          type: GET_POST_BATCHES_BY_LOCATION,
          payload: respJson.data,
        });
      }
    })
    .catch((error) => {
      console.log()
      Toast.fire({
        icon: "error",
        title: "Error al obtener las EcoTiendas",
      });
    });
};
